var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mdb-date-picker-2',{attrs:{"inline":"","options":_vm.options,"title":_vm.title,"label":_vm.label},on:{"getValue":_vm.handleChange},model:{value:(_vm.localDate),callback:function ($$v) {_vm.localDate=$$v},expression:"localDate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }